export function embedMedia() {
    document.addEventListener('DOMContentLoaded', function () {
        // Find all oembed elements with a url attribute
        var oembedElements = document.querySelectorAll('oembed[url]');

        oembedElements.forEach(function (element) {
            var url = element.getAttribute('url');
            if (!url) return;

            var embedData = getEmbedData(url);
            if (!embedData) return;

            var iframe = document.createElement('iframe');
            iframe.src = embedData.src;
            iframe.width = '560';
            iframe.height = '315';
            iframe.allow =
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe.allowFullscreen = true;
            iframe.loading = 'lazy';
            iframe.title = embedData.title;

            // Responsive styles
            iframe.style.aspectRatio = '16 / 9';
            iframe.style.width = '100%';
            iframe.style.height = 'auto';
            iframe.style.display = 'block';
            iframe.style.margin = '1.5rem auto';

            if (element.parentNode) {
            element.parentNode.replaceChild(iframe, element);
            }
        });

        /**
         * Determine provider and return embed info
         */
        function getEmbedData(url) {
            var youtubeId = extractYouTubeId(url);
            if (youtubeId) {
            return {
                src: 'https://www.youtube.com/embed/' + youtubeId,
                title: 'YouTube video player'
            };
            }

            var vimeoId = extractVimeoId(url);
            if (vimeoId) {
            return {
                src: 'https://player.vimeo.com/video/' + vimeoId,
                title: 'Vimeo video player'
            };
            }

            return null;
        }

        /**
         * Extract YouTube ID
         */
        function extractYouTubeId(url) {
            var regex =
            /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            var match = url.match(regex);
            return match ? match[1] : null;
        }

        /**
         * Extract Vimeo ID
         */
        function extractVimeoId(url) {
            var regex =
            /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/(?:video\/)?)(\d+)/;
            var match = url.match(regex);
            return match ? match[1] : null;
        }
    });
}